import { EMPTY_OBJECT } from 'uf/base';
import { useMakeSelector } from 'uf/ui/base/useMakeSelector';
import { makeGetUserFlag } from 'uf/user/selectors/flags';

export default function useUserFlag(flagName: string) {
  const makeSelector = () => makeGetUserFlag(flagName);
  return useMakeSelector(makeSelector, EMPTY_OBJECT);
}
